export default "__VITE_ASSET__84867c6e__"